/* Trivia Quiz — GoPro Mountain Games activation.
   Pure vanilla, no dependencies. Email capture uses Shopify's native
   {% form 'customer' %}, which does a full POST and reloads the page; the
   score is stashed in sessionStorage so the code reveal survives the reload. */
(function () {
  var root = document.querySelector('[data-trivia]');
  if (!root) return;

  root.classList.remove('trivia--no-js');
  root.classList.add('trivia--js');

  var SS_KEY = 'sdgTrivia';
  var code = (root.getAttribute('data-code') || '').trim();
  var redirect = root.getAttribute('data-redirect') || '/collections/all';
  var failLabel = root.getAttribute('data-fail-submit') || 'Join Field Notes';
  var rightLabel = root.getAttribute('data-right-label') || 'Correct.';
  var wrongLabel = root.getAttribute('data-wrong-label') || 'Not this one.';

  var screens = {
    intro: root.querySelector('[data-screen="intro"]'),
    quiz: root.querySelector('[data-screen="quiz"]'),
    result: root.querySelector('[data-screen="result"]')
  };

  var questions = [].slice.call(root.querySelectorAll('[data-question]'));
  var total = questions.length;
  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 3;
  threshold = Math.max(1, Math.min(threshold, total || 1));

  var startBtn = root.querySelector('[data-start]');
  var progressEl = root.querySelector('[data-progress]');
  var feedbackEl = root.querySelector('[data-feedback]');
  var scoreEl = root.querySelector('[data-score]');
  var formWrap = root.querySelector('[data-form-wrap]');
  var tagsInput = root.querySelector('[data-trivia-tags]');
  var submitBtn = root.querySelector('[data-submit]');
  var passBranch = root.querySelector('[data-branch="pass"]');
  var failBranch = root.querySelector('[data-branch="fail"]');
  var passReveal = root.querySelector('[data-pass-reveal]');
  var failReveal = root.querySelector('[data-fail-reveal]');
  var formRetry = formWrap ? formWrap.querySelector('[data-retry]') : null;
  var passLabel = submitBtn ? submitBtn.textContent.trim() : 'Claim';

  var posted = !!root.querySelector('[data-trivia-posted]');
  var hadError = !!root.querySelector('[data-trivia-error]');

  var index = 0;
  var score = 0;

  function show(name) {
    Object.keys(screens).forEach(function (k) {
      if (screens[k]) screens[k].hidden = k !== name;
    });
  }

  function focusEl(el) {
    if (!el) return;
    el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); }
  }

  function showQuestion(i) {
    questions.forEach(function (q, qi) { q.hidden = qi !== i; });
    if (progressEl) progressEl.textContent = 'Question ' + (i + 1) + ' of ' + total;
    if (feedbackEl) {
      feedbackEl.textContent = '';
      feedbackEl.classList.remove('trivia__feedback--wrong');
    }
    focusEl(questions[i] && questions[i].querySelector('[data-option]'));
  }

  function resetQuestions() {
    questions.forEach(function (q) {
      q.removeAttribute('data-locked');
      [].slice.call(q.querySelectorAll('[data-option]')).forEach(function (b) {
        b.classList.remove('is-chosen', 'is-right', 'is-wrong', 'is-answer');
      });
    });
  }

  function setTags(passed) {
    if (!tagsInput) return;
    var base = tagsInput.getAttribute('data-base') || 'newsletter';
    tagsInput.value = base + (passed ? ', trivia-pass' : ', trivia-fail');
  }

  function start() {
    document.documentElement.classList.remove('sdg-trivia-posted');
    try { sessionStorage.removeItem(SS_KEY); } catch (e) {}
    index = 0;
    score = 0;
    resetQuestions();
    show('quiz');
    showQuestion(0);
  }

  function onOptionClick(e) {
    var btn = e.target.closest('[data-option]');
    if (!btn) return;
    var q = btn.closest('[data-question]');
    if (!q || q.getAttribute('data-locked')) return;

    q.setAttribute('data-locked', 'true');
    var correctIndex = parseInt(q.getAttribute('data-correct'), 10);
    var isRight = parseInt(btn.getAttribute('data-option'), 10) === correctIndex;
    if (isRight) score++;

    btn.classList.add('is-chosen', isRight ? 'is-right' : 'is-wrong');
    if (!isRight) {
      var answerBtn = q.querySelector('[data-option="' + correctIndex + '"]');
      if (answerBtn) answerBtn.classList.add('is-answer');
    }
    if (feedbackEl) {
      feedbackEl.textContent = isRight ? rightLabel : wrongLabel;
      feedbackEl.classList.toggle('trivia__feedback--wrong', !isRight);
    }

    // Hold so the marks register; longer on a miss so the right answer can be read.
    window.setTimeout(function () {
      if (index + 1 < total) {
        index++;
        showQuestion(index);
      } else {
        finish();
      }
    }, isRight ? 1000 : 1800);
  }

  function finish() {
    var passed = score >= threshold;
    try {
      sessionStorage.setItem(SS_KEY, JSON.stringify({ score: score, total: total, passed: passed }));
    } catch (e) {}
    renderResult(score, total, passed, false);
  }

  function fillReveal() {
    var codeEl = root.querySelector('[data-code-value]');
    var shop = root.querySelector('[data-shop]');
    var chip = root.querySelector('.trivia__code');
    if (code) {
      if (codeEl) codeEl.textContent = code;
      if (shop) shop.setAttribute('href', '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect));
    } else {
      if (chip) chip.hidden = true;
      if (shop) shop.hidden = true;
    }
  }

  function renderResult(s, t, passed, afterPost) {
    show('result');
    if (scoreEl) scoreEl.textContent = s + ' / ' + t;
    if (passBranch) passBranch.hidden = !passed;
    if (failBranch) failBranch.hidden = passed;
    if (submitBtn) submitBtn.textContent = passed ? passLabel : failLabel;
    if (formRetry) formRetry.hidden = passed;
    if (formWrap) formWrap.hidden = afterPost;
    if (passReveal) passReveal.hidden = !(afterPost && passed);
    if (failReveal) failReveal.hidden = !(afterPost && !passed);
    setTags(passed);
    if (afterPost && passed) fillReveal();

    var focusTarget = passed
      ? (afterPost ? passReveal : passBranch)
      : (afterPost ? failReveal : failBranch);
    focusEl(focusTarget);
  }

  function readStored() {
    try { return JSON.parse(sessionStorage.getItem(SS_KEY)); } catch (e) { return null; }
  }

  /* Wire up */
  if (startBtn) startBtn.addEventListener('click', start);
  if (screens.quiz) screens.quiz.addEventListener('click', onOptionClick);
  [].slice.call(root.querySelectorAll('[data-retry]')).forEach(function (b) {
    b.addEventListener('click', start);
  });

  /* Decide the entry screen */
  if (posted) {
    // The native customer form lights up success on every customer form on the
    // page (e.g. the footer newsletter). Remove those so only our reveal shows.
    [].slice.call(document.querySelectorAll('.newsletter-form__message--success')).forEach(function (el) {
      if (!root.contains(el)) el.remove();
    });
    var d = readStored();
    if (d) {
      score = d.score;
      renderResult(d.score, d.total, d.passed, true);
    } else {
      renderResult(0, total, false, true);
    }
  } else if (hadError) {
    var e2 = readStored();
    if (e2) {
      score = e2.score;
      renderResult(e2.score, e2.total, e2.passed, false);
    } else {
      show('intro');
    }
  } else {
    show('intro');
  }
})();
